// extracted by mini-css-extract-plugin
export default {"badge":"Keywords_badge__HdKsc"};